import React, { FC } from 'react'

export type Props = {
  id: number | string
  handle: string
}

export const YotpoReviews: FC<Props> = ({ id, handle }) => {
  const url = `${window.location.origin}/products/${handle}`

  return (
    <div className="yotpo bottomLine" data-product-id={id} data-url={url}></div>
  )
}
